// extracted by mini-css-extract-plugin
module.exports = {"container":"Tm01kaqx","icon":"_1IQDj7CQ"};